import { DataGridTemplate } from "../../../../shared/data-grid/data-grid.template";
import { RequestDetailService } from "./detail.service";

export class RequestHistoryGrid extends DataGridTemplate {
    private isViewMilestones: boolean;
    editForm: null;

    constructor(
        private readonly detailService: RequestDetailService,
    ) {
        super();
        this.controls.add = false;
        this.controls.edit = false;
        this.controls.delete = false;
        this.controls.excel = false;
        this.controls.customToolBarButtons = this.customToolBarButtons;
        this.title = 'Request History'
        this.saveUserSettings = false;

        this.detailService.history
            .subscribe(x => this.refresh());
    }

    toggleMileStones = () => {
        this.isViewMilestones = !this.isViewMilestones;
        this.gridState.skip = 0;
        this.detailService.refreshHistory(this.isViewMilestones);
    }

    read(opts: any): Promise<any> {
        return Promise.resolve(this.detailService.history.value);
    }

    create(parentEditDataItem: any): void {
        return null;
    }

    edit(dataItem: any): void {
        return null;
    }

    save(dataItem: any, isNew: boolean): Promise<any> {
        return Promise.resolve();
    }

    delete(dataItem: any): Promise<any> {
        return Promise.resolve();
    }


    columns: any[] = [
        {
            field: 'Actor',
            title: 'User',
        },
        {
            field: 'Description',
            title: 'Description',
        },
        {
            field: 'Action',
            title: 'Action',
        },
        {
            field: 'Date',
            title: 'Date',
        },
    ];


    customToolBarButtons = [{
        text: 'Milestones',
        iconClass: 'fa fa-fw fa-filter',
        toggleable: true,
        callback: this.toggleMileStones,
        isSelected: () => this.isViewMilestones
    }]

}
